/**
 * Function that returns lowercase word without:
 * Punctuation, <i> tags, and spaces
 */

const cleanWord = (unCleanWord: string) => {
  let word = unCleanWord;

  // strip <i> tags if included
  if (word.includes("<i>")) {
    const regex = /(<([^>]+)>)/gi;
    word = word.replace(regex, "");
  }

  // trim punctuation
  word = word.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

  // return lowercase for comparison
  word = word.toLowerCase();

  return word.trim();
};

export default cleanWord;
